import React, { Component } from 'react';
import Wrp from '../Wrp/Wrp';

class BootstrapRow extends Component {
    
    render () {
        return (
            <Wrp>
                 <div className="row">
                    {this.props.children}
                 </div>
            </Wrp>
        )
    }
}

export default BootstrapRow;